import { render } from "./ViewComfy.vue.js?vue&type=template&id=bae5ea3e!=!../vue-loader/dist/index.js??ruleSet[0]!./ViewComfy.vue?vue&type=template&id=bae5ea3e"
import script from "./ViewComfy.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./ViewComfy.vue?vue&type=script&lang=js"
export * from "./ViewComfy.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./ViewComfy.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__